import Select from "react-select";

// Generated by GitHub Copilot
const SimpleMenu = (props) => (
  <Select
    classNamePrefix="rs"
    isMulti={props.multiple}
    onChange={props.onChange}
    options={props.options}
    value={props.defaultValue}
    isDisabled={props.disabled || props.readOnly}
    isLoading={props.loading}
    inputId={props.id}
    menuPortalTarget={props.menuPortalTarget}
    styles={props.styles}
  ></Select>
);

export default SimpleMenu;
